import styled from "styled-components"
import { Table as AntdTable } from 'antd';
import { LoadingIcon } from "../icons/LoadingIcon";

const StyledTableContainer = styled.div`
    height: calc(100% - 68px);
    background: #FFFFFF;
    box-shadow: 0px 16px 48px rgba(116, 151, 208, 0.1);
    border-radius: 20px;
    padding: 32px;
    box-sizing: border-box;
`;

export const TableContainer = (props) => <StyledTableContainer>{props.children}</StyledTableContainer>;

const StyledTable = styled(AntdTable).attrs(props => ({
    ...props,
    loading: { spinning: props.loading, indicator: <LoadingIcon spin /> }
}))`
    height: 100%;

    & .ant-table-container, & .ant-spin-nested-loading, & .ant-spin-container,
    & .ant-table, & .ant-table-container {
        height: 100%;
    }

    & .ant-table-body {
        height: calc(100% - 36px);
        border-bottom: 2px solid #D7E3F7;
    }

    & .ant-table-column-sorter-inner {
        display: none;
    }

    & .ant-table-body::-webkit-scrollbar {
        width: 6px;
    }

    & .ant-table-body::-webkit-scrollbar-thumb {
        background: rgba(139, 164, 206, 0.4);
        border-radius: 10px;

        border: 1px solid transparent;
        background-clip: padding-box;
    }

    & .ant-table-body::-webkit-scrollbar-thumb:hover {
      background: rgba(139, 164, 206, 0.6);
      border: 1px solid transparent;
      background-clip: padding-box;
    }

    /* table header */
    & .ant-table-header {
        border-bottom: 2px solid #D7E3F7;
    }

    & .ant-table-thead th {
        padding: 9px 12px;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        text-transform: uppercase;
        background: #FFFFFF;
        color: #8898B3;
        border: none;
    }

    & .ant-table-thead th:hover {
        background: #FFFFFF;
    }

    & tr:nth-child(even):hover > td,
    & tr:nth-child(even) > td {
        background: #FFFFFF;
    }

    & tr:nth-child(odd):not(:first-child) > td,
    & tr:nth-child(odd):not(:first-child):hover > td {
        background: #F6F9FF;
    }

    & .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
        background: transparent;
    }

    & .ant-table-column-sort {
        background: transparent;
    }

    & .ant-table-tbody > tr > td {
        padding: 13px;
        font-size: 14px;
        line-height: 22px;
        color: var(--sp-text-color);
        border: none;
    }
`;

export const Table = (props) => <StyledTable {...props} />